import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

const StyledTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.institutional.braskemGray,
  fontWeight: "bold",
}));

export default StyledTitle;